import { Injectable, inject } from "@angular/core";
import { orderBy } from "lodash";
import { BehaviorSubject, Observable } from "rxjs";
import { BusyService } from "~app/common/components/busy/busy.service";
import { ExternArbetsorderStatus } from "~app/common/models/constants";
import { ApiClientService } from "~app/common/services/api-client.service";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ExternArbetsorderViewModel } from "../models/ExternArbetsorderViewModel";
import { ICKLeverantorResponse } from "../models/ICKLeverantor";
import { IExternArbetsorderDetails } from "../models/IExternArbetsorderDetails";
import { IExternArbetsorderSearchFilter } from "../models/IExternArbetsorderSearchFilter";
import { IProduktionsomrade } from "../models/IProduktionsomrade";
import { ISearchExternArbetsorderResponse } from "../models/ISearchExternArbetsorderResponse";
import { ITransportforetag } from "../models/ITransportforetag";

@Injectable({
    providedIn: "root"
})
export class ExternArbetsorderService {
    searchResult$ = new BehaviorSubject<ExternArbetsorderViewModel[]>(null);

    private readonly busyService = inject(BusyService);
    private readonly http = inject(ApiClientService);

    getAllProduktionsomraden(): Observable<IProduktionsomrade[]> {
        return this.http.get<IProduktionsomrade[]>("administration/produktionsomrade/", false);
    }

    getAllTransportforetag(): Observable<ITransportforetag[]> {
        return this.http.get<ITransportforetag[]>("transportforetag/", false);
    }

    getAllUppdragsgivare(): Observable<ICKLeverantorResponse> {
        return this.http.get<ICKLeverantorResponse>("CKLeverantor/", false);
    }

    getExternarbetsorderDetails(id: number): Observable<IExternArbetsorderDetails> {
        return this.http.get<IExternArbetsorderDetails>(`externarbetsorder/${id}`, false);
    }

    getIcon(status: string, viol3Dirty: boolean, viol3Fel: boolean): string {
        switch (status) {
            case ExternArbetsorderStatus.Ok: {
                let color = viol3Dirty ? "dirty" : "success";
                if (viol3Fel) {
                    color = "error";
                }
                return `far fa-check-circle ${color}`;
            }
            case ExternArbetsorderStatus.Fel: {
                return "far fa-exclamation-triangle error";
            }
            case ExternArbetsorderStatus.Ignorerad: {
                return "far fa-exclamation-square warning";
            }
            case ExternArbetsorderStatus.Inaktiv: {
                return "far fa-exclamation-square warning";
            }
            default:
                return "far fa-exclamation-square";
        }
    }

    searchForExternArbetsorder(params: IExternArbetsorderSearchFilter) {
        params = ObjectUtils.removeUndefinedProperties(params, true);
        this.busyService.addWork(this.http.get<ISearchExternArbetsorderResponse[]>("externarbetsorder/", false, params)).subscribe(x => {
            this.searchResult$.next(orderBy(x, r => r.uppdateratViol, "desc").map(z => new ExternArbetsorderViewModel(z)));
        });
    }
}
